
import FileInput from "../../../common/input/FileInput";

export default function FieldImage({ image, onChange }) {
	const existingPreviewUrl = typeof image === "string" ? image : "";
	return (
		<FileInput
			onChange={onChange}
			label="تصویر جلسه"
			existingPreviewUrl={existingPreviewUrl}
		/>
	);
}
